import { Injectable } from '@angular/core';
import { GameRootService, STORE_GAME_KEY } from '@core/services/game-root.service';
import { CentrifugoService, Game, VolleyballGameApi } from '@mtgame/core';

@Injectable()
export class VolleyballGameRootService extends GameRootService {
  constructor(
    protected volleyballGameApi: VolleyballGameApi,
    protected centrifugoService: CentrifugoService
  ) {
    super(centrifugoService);
  }

  async getGame(gameId: number): Promise<Game> {
    const game = await this.volleyballGameApi.getById(gameId);
    this.store.save(STORE_GAME_KEY, game);
    return game;
  }

  protected onGameUpdated(game: Game, oldGame: Game): void {
    game.volleyballGameConfig = oldGame.volleyballGameConfig;
  }
}
